import { Content, Root, Trigger } from '@radix-ui/react-collapsible'
import { ChevronDown } from 'lucide-react'
import { ComponentPropsWithRef, ElementRef, forwardRef } from 'react'

import { cn } from '@/ui/utils/style'

const Collapsible = Root

const CollapsibleTrigger = forwardRef<ElementRef<typeof Trigger>, ComponentPropsWithRef<typeof Trigger>>(
  ({ children, className, ...props }, ref) => {
    return (
      <Trigger
        ref={ref}
        className={cn(
          'flex w-full items-center justify-between',
          'focus-visible:rounded-sm focus-visible:outline-hidden focus-visible:ring-3',
          'focus-visible:ring-primary-200 focus-visible:ring-offset-0',
          '[&[data-state=open]>svg]:icon-primary [&[data-state=open]>svg]:rotate-180',
          className,
        )}
        {...props}
      >
        {children}
        <ChevronDown className="icon-secondary size-5 shrink-0 transition-transform duration-200" />
      </Trigger>
    )
  },
)
CollapsibleTrigger.displayName = 'CollapsibleTrigger'

const CollapsibleContent = forwardRef<ElementRef<typeof Content>, ComponentPropsWithRef<typeof Content>>(
  ({ children, className, ...props }, ref) => {
    return (
      <Content
        ref={ref}
        className={cn(
          'overflow-hidden',
          'data-[state=open]:animate-collapsible-panel-down',
          'data-[state=closed]:animate-collapsible-panel-up',
        )}
        {...props}
      >
        <div className={className}>{children}</div>
      </Content>
    )
  },
)
CollapsibleContent.displayName = 'CollapsibleContent'

export { Collapsible, CollapsibleContent, CollapsibleTrigger }
